<div class="active-season__title">
  <span>{{ 'flu.dashboard.requests' | cxTranslate }}</span>
</div>
<div class="dashboard-container">
  <div class="row align-items-center mb-3">
    <!-- All requests / Open Requests Toggler -->
    <div class="col-6" *ngIf="reservationList$ | async as ordersList">
      <div
        class="d-flex align-items-center gap-1"
        (click)="toggleOpenRequests()">
        <span>{{ 'flu.dashboard.openRequests' | cxTranslate }}</span>
        <div
          class="dashboard-reservation__requests-toggler"
          [ngClass]="{
            'dashboard-reservation__requests-toggler--active': !(
              openRequestsToggled$ | async
            ),
          }"></div>
        <span class="c-toggle__text">
          {{ 'flu.dashboard.allRequests' | cxTranslate }}
        </span>
      </div>
    </div>

    <h4 class="col-12" *ngIf="!(reservationList$ | async)">
      {{ 'ordersList.noOrders' | cxTranslate }}
    </h4>

    <table
      aria-describedby="reservationTable"
      id="reservationTable"
      class="c-table c-table--branded d-none d-lg-table reservationTable"
      *ngIf="reservationList$ | async as ordersList">
      <thead>
        <tr *ngIf="{ isPharmacyUser: isPharmacyUser$ | async } as data">
          <th scope="col">{{ 'ordersList.date' | cxTranslate }}</th>
          <th scope="col">{{ 'ordersList.request' | cxTranslate }}</th>
          <th scope="col">
            {{
              'ordersList.' +
                (data.isPharmacyUser ? 'physicianName' : 'pharmacyName')
                | cxTranslate
            }}
          </th>
          <th scope="col">
            {{
              'ordersList.' +
                (data.isPharmacyUser ? 'physicianEmail' : 'pharmacyEmail')
                | cxTranslate
            }}
          </th>
          <th scope="col">
            {{
              'ordersList.' +
                (data.isPharmacyUser ? 'physicianAddress' : 'pharmacyAddress')
                | cxTranslate
            }}
          </th>
          <th scope="col">{{ 'ordersList.status' | cxTranslate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of ordersList; let i = index">
          <td>
            {{
              data?.created || data?.creationTime
                | slice: 0 : 10
                | date: DATE_FORMAT
            }}
          </td>
          <td>
            <a
              class="c-link"
              [routerLink]="['/influenza/reservation-overview', data.code]"
              >{{ data.purchaseOrderNumber }}</a
            >
          </td>
          <ng-container
            *ngIf="
              (isPharmacyUser$ | async)
                ? data.user
                : data.associatedUnit as contactData
            ">
            <td>{{ contactData.name }}</td>
            <td>
              {{
                contactData.email ||
                  contactData.influenzaContactInfos?.[0].email
              }}
            </td>
            <td>
              {{
                contactData.billingAddress?.formattedAddress ||
                  data?.billingAddress?.formattedAddress
              }}
            </td>
            <td>{{ data.state }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>

    <!-- For the future -->
    <!-- <section class="d-flex justify-content-center col-12">
      <div id="prod-pagination">
        <p class="text-fixed-medium mb-2">
          {{ 'ordersList.showing' | cxTranslate }} &nbsp;
          <span class="no_rec">{{ end }}</span
          >&nbsp; {{ 'ordersList.of' | cxTranslate }} &nbsp;
          <span class="no_rec">{{ totalOrders }}</span
          >&nbsp; {{ 'ordersList.orders' | cxTranslate }}
        </p>
        <div class="c-pagination align-btns">
          <button
            [disabled]="curPage == 1"
            (click)="getCurrentPage('prev')"
            class="c-pagination-btns mr-1">
            <i class="fa fa-chevron-left"></i>
          </button>

          <button
            class="c-pagination-btns"
            [disabled]="
              curPage >= totalOrders / pageSize ||
              (totalOrders === 0 && pageSize === 0)
            "
            (click)="getCurrentPage('next')">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
        <p class="text-fixed-medium">
          <span
            >{{ 'ordersList.page' | cxTranslate }} {{ curPage }}
            {{ 'ordersList.of' | cxTranslate }} {{ numberOfPages() }}
          </span>
        </p>
      </div>
    </section> -->
  </div>
</div>
